import React from 'react'

export const ShoppingConsole = () => {
    return (
        <div>
            Mi carrito de compras
        </div>
    )
}
